import type {
  GetMembershipQuery,
  GetUserAccountQuery,
  Maybe,
} from "~/generated/graphql";

const ACTIVATED_STATUS = "ACTIVATED";

export const isMembershipActivated = (
  membership: Maybe<GetMembershipQuery> | undefined,
): boolean => {
  return membership?.membership?.status === ACTIVATED_STATUS || false;
};

export const isMembershipActivatedWithUserAccountData = (
  membershipData: GetUserAccountQuery | null,
): boolean => {
  return membershipData?.userAccount?.userMembership?.isActive || false;
};
